module.exports = __webpack_public_path__ + "static/img/77092J_R_2_20171016_LC.8434101.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/77092J_R_2_20171016_LC.png
// module id = Wd1u
// module chunks = 0